import {GameView} from "../base/GameView";
import * as PIXI from 'pixi.js';
import {Spine} from "@esotericsoftware/spine-pixi-v8";
import {AbstractPixiRoot} from "../AbstractPixiRoot";
import {GameDelayCall} from "../base/GameJuggler";
import {TrackEntry} from "@esotericsoftware/spine-core/dist/AnimationState";
import {Assets} from "pixi.js";

export class SpineMovie extends GameView {

  private readonly _spine: Spine;
  private readonly _touchableQuad?: PIXI.Sprite;
  private _durationDelayCall?: GameDelayCall;
  private _currentCallback?: (() => void) | null;

  constructor(skeleton: string, atlas: string) {
    super();

    const cache = Assets.cache;
    const skeletonValue = cache.get(skeleton);
    const atlasValue = cache.get(atlas);

    this._spine = Spine.from({
      skeleton: skeleton,
      atlas: atlas,
      // scale: App.multiply(),
      autoUpdate: true, // todo
      darkTint: false,
    });
    this.addChild(this._spine);
    this.interactive = false;

    // const bounds = this._spine.getLocalBounds();
    // this._touchableQuad = ViewUtils.createGreenQuad(bounds.width, bounds.height, 0.5);
    // this._touchableQuad.x = bounds.minX;
    // this._touchableQuad.y = bounds.minY;
    // this._touchableQuad.interactive = false;
    // this.addChild(this._touchableQuad);
  }

  override destroy(): void {
    if (!this.destroyed) {
      this._spine.autoUpdate = false;
      this._durationDelayCall?.destroy();
      this._touchableQuad?.destroy();
      this._spine.destroy();
      // this._spine.destroy({
      //   texture: true // Should it destroy the current texture of the renderable as well
      // })
      super.destroy();
    }
  }

  override addToJuggler(): void {
    this.juggler?.addAnimatable(this);
  }

  override removeFromJuggler() {
    this.juggler?.removeAnimatable(this);
  }

  override advanceTime(time: number): void {
    if (this._spine) {
      // this._spine.update(time); // todo
      // console.log(time);
    }
  }

  public playLoop(animationName: string, fromDelta: number = 0) {
    this.addToJuggler();
    this._durationDelayCall?.destroy();
    this._currentCallback = null;
    this._spine.state.clearListeners();
    this._spine.state.setAnimation(0, animationName, true);
    this._spine.update(fromDelta);
    return this;
  }

  public playOnce(animationName: string, onComplete: (() => void) | null = null): SpineMovie {
    this.addToJuggler();
    this._currentCallback = null;
    this._durationDelayCall?.destroy();
    this._spine.state.clearListeners();
    this._spine.state.setAnimation(0, animationName, false);
    if (onComplete) {
      this._currentCallback = onComplete;
      this._spine.state.addListener({
        complete: this.onAnimationComplete.bind(this)
      });
    }
    return this;
  }

  public playDuration(animationName: string, durationSec: number, onEndCallback: () => void): SpineMovie {
    this.addToJuggler();
    this._currentCallback = null;
    this._durationDelayCall?.destroy();
    this._spine.state.clearListeners();
    if (onEndCallback) {
      this._durationDelayCall = this.juggler.delayCall(onEndCallback, durationSec);
    }
    this._spine.state.setAnimation(0, animationName, false);
    return this;
  }

  public stop() {
    this.removeFromJuggler();
    return this;
  }

  private onAnimationComplete(entry: TrackEntry): void {
    // if (entry.animation.name === "animation_name") {
    //   App.log("Анимация завершилась:", entry.animation.name);
    //   // Ваш код для обработки завершения анимации
    // }
    if (this._currentCallback) {
      this._currentCallback();
    }
  }
}
